import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_AM_PI: string = `
3 as rank,
id,
label,
attributes
`;

export const order_AM_PI  = 'rank DESC, label';

const getAttributes = (rawName: string) => ({
    vnomgpm: `$.3463.${rawName}`,
});

export const buildQuery_AM_PI: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT
                       cast(vnomAttr.value as float) as vnom,
                       product.id,
                       label,
                       attributes
                    FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.vnomgpm}`)}) as vnomAttr
                    WHERE ${filter})
            , user_input as (SELECT cast(? as float) as v100)
            , bounds as (SELECT
                             CASE WHEN v100 < 76 THEN 100 ELSE round(v100 * 3, 1) END as upper,
                             v100 as lower,
                             v100
                         FROM user_input)
            SELECT
                ${selectFields}
                       FROM products_filtered
                       JOIN bounds
                       WHERE products_filtered.vnom between bounds.lower and bounds.upper
        `,
        [volumetricFlow]
    ];
}



